import {batch, computed, signal} from "@preact/signals-react";
import {
    acriss,
    bookingWeeks,
    categories,
    currency,
    lengthRental,
    markets,
    offices,
    providers,
    rentalDates,
    sites,
    transmission,
    dailyPrice,
    isOfficeGroup,
    officeGroup,
    isSiteGroup,
    siteGroup
} from "@signals";
import {AGGREGATION_PRICE} from "./@constants";

export const europcarPricingEnvAgregationPrice = signal(AGGREGATION_PRICE.MIN)

export const resetPricingEnvFilters = () => batch(() => {
    offices.value = null
    sites.value = null
    rentalDates.value = []
    providers.value = []
    categories.value = []
    lengthRental.value = null
    acriss.value = []
    transmission.value = []
    currency.value = null
    europcarPricingEnvAgregationPrice.value = AGGREGATION_PRICE.MIN
})

export const europcarPricingEnvFilters = computed(() => ({
    reportType: "pricing-environment",
    bookingWeek: bookingWeeks.value,
    pickupDate: rentalDates.value,
    officePickupID: offices.value,
    providerID: providers.value,
    categoryID: categories.value,
    lor: lengthRental.value,
    acriss: acriss.value,
    market: markets.value,
    siteID: sites.value,
    automatic: transmission.value,
    currency: currency.value,
    tabKey: europcarPricingEnvAgregationPrice.value,
    isDailyPrice: dailyPrice.value,
    isOfficeGroup: isOfficeGroup.value,
    officeGroupID: officeGroup.value,
    isSiteGroup: isSiteGroup.value,
    siteGroupID: siteGroup.value
}))